// extracted by mini-css-extract-plugin
module.exports = {"navPrimary":"navigation_navPrimary__dNwN2","navSecondary":"navigation_navSecondary__27GeU","navContainer":"navigation_navContainer__9lWgq"};